export const ROOT_PATH = '/index.html#';
export const HOME_PATH = '/app';
export const RANKING_PATH = '/ranking';
export const FRIENDS_PATH = '/friends';
export const EARN_PATH = '/earn';
export const LEADERBOARD_PATH = '/leaderboard';
export const DISTRIBUTION_PATH = '/distribution';
export const FORTUNE_WHEEL_PATH = '/fortune-wheel';

export const HACKATHON_PROJECT_DETAILS_PATH = '/app/hackaton/:documentId';
export const ACTIVITY_PATH = '/app/activity';
export const HOLIDAY_GIVEAWAY = '/giveaway';

export const WALLET_REDIRECT = '/wallet-redirect.html';
